import * as Types from '../graphQlTypes.generated';

import { graphQlService } from '@doxyme/frontend/services/graphql.service';
export type GetAnalyticsQueryVariables = Types.Exact<{
  input: Types.GetAnalyticsInput;
}>;


export type GetAnalyticsQuery = { __typename?: 'Query', getAnalytics: { __typename?: 'Analytics', averageSessions: number, growthInPercent?: number | null, totalDuration?: number | null, totalSession: number, dataByDate: Array<{ __typename?: 'DateTotals', averageDurationPerMonth: number, date: string, totalDurationPerMonth: number, totalSessionPerMonth: number }>, maxDurationInMonth?: { __typename?: 'DateTotals', averageDurationPerMonth: number, date: string, totalDurationPerMonth: number, totalSessionPerMonth: number } | null, maxSessionsInMonth?: { __typename?: 'DateTotals', averageDurationPerMonth: number, date: string, totalDurationPerMonth: number, totalSessionPerMonth: number } | null } };

export type GetAnalyticsOverviewQueryVariables = Types.Exact<{
  input: Types.GetAnalyticsOverviewInput;
}>;


export type GetAnalyticsOverviewQuery = { __typename?: 'Query', getAnalyticsOverview: { __typename?: 'AnalyticsOverview', averageDurationForOverview?: number | null, totalDurationForOverview?: number | null, totalSessionForOverview?: number | null } };


export const GetAnalyticsDocument = `
    query GetAnalytics($input: GetAnalyticsInput!) {
  getAnalytics(input: $input) {
    averageSessions
    dataByDate {
      averageDurationPerMonth
      date
      totalDurationPerMonth
      totalSessionPerMonth
    }
    growthInPercent
    maxDurationInMonth {
      averageDurationPerMonth
      date
      totalDurationPerMonth
      totalSessionPerMonth
    }
    maxSessionsInMonth {
      averageDurationPerMonth
      date
      totalDurationPerMonth
      totalSessionPerMonth
    }
    totalDuration
    totalSession
  }
}
    `;
export const GetAnalyticsOverviewDocument = `
    query GetAnalyticsOverview($input: GetAnalyticsOverviewInput!) {
  getAnalyticsOverview(input: $input) {
    averageDurationForOverview
    totalDurationForOverview
    totalSessionForOverview
  }
}
    `;

const injectedRtkApi = graphQlService.injectEndpoints({
  endpoints: (build) => ({
    GetAnalytics: build.query<GetAnalyticsQuery, GetAnalyticsQueryVariables>({
      query: (variables) => ({ document: GetAnalyticsDocument, variables })
    }),
    GetAnalyticsOverview: build.query<GetAnalyticsOverviewQuery, GetAnalyticsOverviewQueryVariables>({
      query: (variables) => ({ document: GetAnalyticsOverviewDocument, variables })
    }),
  }),
});

export { injectedRtkApi as api };
export const { useGetAnalyticsQuery, useLazyGetAnalyticsQuery, useGetAnalyticsOverviewQuery, useLazyGetAnalyticsOverviewQuery } = injectedRtkApi;

